import qs from "qs";

export class RatingClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/ratings`;
  }

  async getReport(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/report${queryString}`;

    const config = params && params.format === "xlsx"
      ? { responseType: "blob" }
      : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }

  async getTermiteControlServiceReport() {
    const url = `${this.baseURL}/home_health/subscribed_services/termite_control/report`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async postFormRating(params) {
    const url = `${this.baseURL}/forms/submit`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async updateAdminAssignAppointmentToContact(adminId, params) {
    const url = `${this.baseURL}/contact/appointment/${adminId}/agent`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async putFormRating(appointmentId, params) {
    const url = `${this.baseURL}/forms/submit/${appointmentId}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }
}
